import { jsx as _jsx } from "react/jsx-runtime";
import { useBreakpoints } from 'pe-core-frontend';
import { createContext, useEffect, useState } from 'react';
export var AnimateDirection;
(function (AnimateDirection) {
    AnimateDirection["RTL"] = "RTL";
    AnimateDirection["LTR"] = "LTR";
})(AnimateDirection || (AnimateDirection = {}));
const DefaultAnimateContext = {
    animate: true,
    animateDirection: AnimateDirection.RTL,
    setAnimateDirection: (_dir) => { },
    setAnimate: () => { },
};
export const AnimateContext = createContext(DefaultAnimateContext);
export const AnimateContextProvider = ({ children }) => {
    const [animate, setAnimate] = useState(DefaultAnimateContext.animate);
    const [animateDirection, setAnimateDirection] = useState(DefaultAnimateContext.animateDirection);
    const { isMobile } = useBreakpoints();
    useEffect(() => {
        setAnimate(isMobile);
    }, [isMobile]);
    const value = {
        ...DefaultAnimateContext,
        animate,
        animateDirection,
        setAnimate,
        setAnimateDirection,
    };
    return _jsx(AnimateContext.Provider, { value: value, children: children });
};
